import { IImportLeadPayload } from '../types/api';
import { IProduct } from '../types/product';

import { Api } from './api';

export type KlaviyoPushPrams =
  | [
      'identify' | 'track' | 'trackViewedItem',
      (
        | 'Viewed Product'
        | 'Started Checkout'
        | 'Added to Cart'
        | Record<string, unknown>
      ),
      Record<string, unknown>,
    ]
  | ['identify' | 'track' | 'trackViewedItem', Record<string, unknown>];

export class Klaviyo {
  private static push = (params: KlaviyoPushPrams) => {
    if (!window._learnq) {
      window._learnq = [];
    }
    window._learnq?.push(params);
  };

  static trackActiveOnSite = (lead: Partial<IImportLeadPayload>) => {
    if (lead?.emailAddress && lead.emailAddress.startsWith('qa+')) {
      return;
    }

    Klaviyo.push([
      'identify',
      {
        $first_name: lead?.firstName || '',
        $last_name: lead?.lastName || '',
        $email: lead?.emailAddress,
        $phone_number:
          String(lead?.phoneNumber)
            ?.replace('+', '')
            ?.trim() || '',
      },
    ]);
  };

  static trackViewedProduct = (product: IProduct) => {
    Klaviyo.push([
      'track',
      'Viewed Product',
      {
        id: Number(product?.id),
        name: product?.name,
        imageURL: product.image,
        url: window.location.href,
        price: String(product.finalPrice),
        checkoutURL: window.location.href,
      },
    ]);

    Klaviyo.push([
      'trackViewedItem',
      {
        ItemId: product.id,
        Title: product.name,
        Price: String(product.finalPrice),
      },
    ]);
  };

  static trackStartedCheckout = (
    email: string,
    firstName: string,
    lastName: string,
    product: IProduct,
    locale: string,
  ) => {
    Api.sendStartedCheckoutEvent({
      email,
      first_name: firstName,
      last_name: lastName,
      locale,
      client: window.BRAND,
      value: product.finalPrice,

      Items: JSON.stringify([
        {
          Quantity: 1,
          ProductID: product.id,
          imageURL: product.image,
          ProductName: product.name,
          RowTotal: product.finalPrice,
          ItemPrice: product.finalPrice,
          ProductURL: window.location.href,
          checkoutURL: window.location.href,
        },
      ]),
    });
  };

  static trackStartedCheckoutV2 = (
    email: string,
    firstName: string,
    lastName: string,
    product: IProduct,
    locale: string,
    phone_number?: string,
  ) => {
    if (!window.IS_1_CLICK) {
      const metaElement = (document.querySelector(
        'meta[name="product-subcategory"]',
      ) ||
        document.getElementById(
          'productSubCategory',
        )) as HTMLMetaElement | null;
      const metaContent = metaElement?.content;

      const payload: any = {
        email,
        first_name: firstName,
        last_name: lastName,
        locale,
        client: window.BRAND,
        country: window.GEO.country,
        city: window.GEO.city,
        timezone: window.GEO.timezone,
        region: window.GEO.region,
        ipAddress: window.GEO.ip,
        zipCode: window.GEO.postalCode,
        value: product.finalPrice,
        phone_number,
        Items: JSON.stringify([
          {
            Quantity: 1,
            ProductID: product.id,
            imageURL: product.image,
            ProductName: product.name,
            RowTotal: product.finalPrice,
            ItemPrice: product.finalPrice,
            ProductURL: window.location.href,
            checkoutURL: window.location.href,
          },
        ]),
      };

      if (metaContent) {
        payload.productSubCategory = metaContent;
      }

      Api.sendStartedCheckoutEventV2(payload);
    }
  };

  static trackAddToCart = (lead: IImportLeadPayload, product: IProduct) => {
    if (lead?.emailAddress && lead.emailAddress.startsWith('qa+')) {
      return;
    }

    Klaviyo.trackActiveOnSite(lead);

    Klaviyo.push([
      'track',
      'Added to Cart',
      {
        $value: product.finalPrice,
        AddedItemProductName: product.name,
        AddedItem_Quantity: 1,
        Items: [
          {
            ProductID: product.id,
            ProductName: product.name,
            Quantity: 1,
            ItemPrice: product.finalPrice,
            imageURL: product.image,
            ProductURL: window.location.href,
            checkoutURL: window.location.href,
          },
        ],
      },
    ]);
  };
}
